import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Create, Visibility, Add, CheckCircleOutline, OpenInBrowser, Apps, RestoreFromTrash } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { Link } from 'react-router-dom';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsCreate, wsUpdate } from 'services/WService';

import ProgressBar from 'components/Tvendo/Common/ProgressBar';
import ModalSupervisor from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { TextField, Tooltip } from '@material-ui/core';
import Badge from 'components/Badge/Badge';
import { formatDate } from 'hooks/Pipe';
import RegularButton from 'components/CustomButtons/Button';
import moment from 'moment';
import { wsFindBy } from 'services/WService';
import UserAppModal from 'components/Tvendo/Setting/User/UserAppModal';
import ButtonResetPassword from 'components/Tvendo/Common/ButtonResetPassword';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';
import { wsGetAll } from 'services/WService';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 245 },
  { Header: 'Jornada', accessor: 'workDay', width: 150, excelEnabled: false },
  { Header: 'Avance', accessor: 'advance', width: 200, excelEnabled: false },
  { Header: 'Código', accessor: 'code', width: 120 },
  { Header: 'DNI', accessor: 'dni', width: 180 },
  { Header: 'Celular', accessor: 'phone', width: 120 },
  { Header: 'Nombre', accessor: 'name', width: 300 },
  { Header: 'Fecha', accessor: 'fecha', width: 120 },
  { Header: 'Inicio', accessor: 'fecha_inicio', width: 120 },
  { Header: 'Fin', accessor: 'fecha_fin', width: 120 },
  { Header: 'Inicio Operaciones', accessor: 'start_operation_day', width: 170 },
  { Header: 'Cierre Operaciones', accessor: 'end_operation_at', width: 170 },
  { Header: 'Dentro Ruta', accessor: 'within_route', width: 120 },
  { Header: 'Cuota', accessor: 'quota', width: 100 },
  { Header: 'Ventas', accessor: 'sales', width: 100 },
  { Header: 'Avance%', accessor: 'progress_percentage', width: 100 },
  { Header: 'Estado', accessor: 'state', width: 120 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Supervisor(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [supervisores, setSupervisores] = useState([]);
  const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
  const [processing, setProcessing] = useState(false);
  const [zones, setZones] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [userAppModel, setUserAppModel] = useModal();
  const [dataLoading, setDataLoading] = useState(false);
  const TWCol = columns.reduce((sum, col) => sum + (col.width || 0), 0);
  const [trashed, setTrashed] = useState(false);

  async function loadSupervisores() {
    setDataLoading(true);
    setSupervisores([]);
    let zones = selectedZones.map(zone => zone.id);
    let response = await wsFindBy('base/supervisor', { date, zones, trashed: trashed ? 'Y' : 'N' });
    setDataLoading(false);
    if (response.success) {
      response.data = response.data.map((supervisor) => {
        if (supervisor.work_days.length > 0) {
          supervisor.workDay = supervisor.work_days[0];
        } else {
          supervisor.workDay = null;
        }
        delete supervisor.work_days;
        return supervisor;
      });
      setSupervisores(response.data);
    }
  }

  async function loadZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) {
      setZones(response.data);
    }
  }

  async function openWorkDay(supervisor) {
    let res = await wsUpdate(`base/supervisor/${supervisor.id}/reopen-work-day`);
    if (res.success) {
      loadSupervisores();
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function validateWorkDays() {
    setProcessing(true);
    let res = await wsCreate(`base/supervisor/validate-work-days`);
    setProcessing(false);
    if (res.success) {
      loadSupervisores();
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function restoreSupervisor(staff) {
    setDataLoading(true);
    let response = await wsUpdate(`base/supervisor/${staff.id}/restore`);
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      loadSupervisores();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    loadZones();
  }, []);

  useEffect(() => {
    loadSupervisores();
  }, [date, selectedZones, trashed]);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <UserAppModal
        model={userAppModel}
        setOpen={setUserAppModel}
        showNotify={showNotify}
        // canCreate={false}
        canDelete={false}
      />
      <ModalSupervisor
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={loadSupervisores}
      />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de Supervisores{dataLoading && <LoadingSpinner />}</h4>

            <button onClick={() => setTrashed((trashed) => !trashed)}>
              {trashed ? 'Ver activos' : 'Ver eliminados'}
            </button>
            <GridContainer>
              <GridItem xs={4}>
                <TextField
                  type="date"
                  label="Fecha"
                  value={date}
                  onChange={(e) => {
                    setDate(e.target.value);
                  }}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                />
              </GridItem>
              <GridItem xs={4}>
                <MultiComplete
                  label="Zona"
                  selectAll
                  limitTags={1}
                  // fullWidth={false}
                  textField="description"
                  options={zones}
                  disabled={processing}
                  selected={selectedZones}
                  setSelected={setSelectedZones}
                />
              </GridItem>
              <GridItem xs={2}>
                <RegularButton
                  color="success"
                  disabled={processing}
                  onClick={() => {
                    validateWorkDays();
                  }}
                >
                  Validar Dentro Ruta
                </RegularButton>
              </GridItem>
            </GridContainer>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Supervisores"
              defaultWidth={TWCol}
              columns={columns}
              data={supervisores.map((supervisor, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                    {supervisor.deleted_at === null ? (
                      <>
                      <Link to={`${supervisor.id}?date=${date}`}>
                        <Button justIcon round simple color={props.themeContext.buttonColor}>
                          <Visibility />
                        </Button>
                      </Link>
                      <Button
                        justIcon
                        round
                        simple
                        color={props.themeContext.buttonColorWarning}
                        onClick={() => setOpen(supervisor)}
                      >
                        <Create />
                      </Button>
                      <ButtonDelete
                        entity="base/supervisor"
                        id={supervisor.id}
                        reload={loadSupervisores}
                      />

                      <Button
                        justIcon
                        round
                        simple
                        color="info"
                        onClick={() => {
                          setUserAppModel({
                            open: true,
                            ...supervisor,
                            id: supervisor.oauth_user_id,
                          });
                        }}
                      >
                        <Apps />
                      </Button>
                      <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER_CHANGE_PASSWORD}>
                        <ButtonResetPassword
                          userId={supervisor.oauth_user_id}
                          nombre={supervisor.name}
                        />
                      </AllowedGuard>

                      {supervisor.workDay === null ? (
                        <Tooltip title="Jornada no iniciada">
                          <Button justIcon round simple disabled color="success">
                            <CheckCircleOutline />
                          </Button>
                        </Tooltip>
                      ) : supervisor.workDay.status === 'O' ? (
                        <Tooltip title="Jornada iniciada">
                          <Button justIcon round simple color="success">
                            <CheckCircleOutline />
                          </Button>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Re-abrir jornada">
                          <Button justIcon round simple onClick={() => openWorkDay(supervisor)}>
                            <OpenInBrowser style={{ color: '#00acc1' }} />
                          </Button>
                        </Tooltip>
                      )}
                      </>
                    ) : (
                      <>
                      {/* <AllowedGuard permission={ConstantPermissions.PROG_DISTRIBUTION_STAFF_UPDATE}> */}
                        <Button
                          justIcon
                          round
                          simple
                          onClick={() => restoreSupervisor(supervisor)}
                          color="success"
                        >
                          <RestoreFromTrash />
                        </Button>
                      {/* </AllowedGuard> */}
                      </>
                    )}
                    </div>
                  ),
                  workDay: (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Badge
                          color={
                            supervisor.workDay?.status === 'O'
                              ? 'success'
                              : supervisor.workDay?.status === 'C'
                              ? 'danger'
                              : supervisor.workDay === null
                              ? 'info'
                              : ''
                          }
                        >
                          {supervisor.workDay?.status === 'O'
                            ? 'Abierto'
                            : supervisor.workDay?.status === 'C'
                            ? 'Cerrado'
                            : supervisor.workDay === null
                            ? 'Sin abrir'
                            : '-'}
                        </Badge>
                      </div>
                      <div>
                        <p style={{ margin: 0, textAlign: 'center' }}>
                          {!!supervisor.workDay?.start_date
                            ? formatDate(supervisor.workDay?.start_date, 'H')
                            : '-'}
                        </p>
                        <p style={{ margin: 0, textAlign: 'center' }}>
                          {!!supervisor.workDay?.end_date
                            ? formatDate(supervisor.workDay?.end_date, 'H')
                            : '-'}
                        </p>
                      </div>
                    </div>
                  ),
                  advance: (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <div>
                        <ProgressBar progress={parseInt(supervisor.progress_percentage)} />
                        <p style={{ margin: 0 }}>
                          S/{parseFloat(supervisor.progress).toFixed(2)} de S/
                          {parseFloat(supervisor.quota).toFixed(2)}
                        </p>
                      </div>
                    </div>
                  ),
                  end_date: '',
                  name: supervisor.name,
                  fecha: !!supervisor.workDay?.day ? formatDate(supervisor.workDay?.day, 'F') : '-',
                  fecha_inicio: !!supervisor.workDay?.start_date
                    ? formatDate(supervisor.workDay?.start_date, 'H')
                    : '-',
                  fecha_fin: !!supervisor.workDay?.end_date
                    ? formatDate(supervisor.workDay?.end_date, 'H')
                    : '-',
                  start_operation_day: !!supervisor.workDay?.start_operation_at ? formatDate(supervisor.workDay?.start_operation_at, 'H') : '-',
                  end_operation_at: !!supervisor.workDay?.end_operation_at ? formatDate(supervisor.workDay?.end_operation_at, 'H') : '-',
                  within_route: supervisor.workDay?.within_route === true ? 'Si' : 'No',
                  quota: parseFloat(supervisor.quota).toFixed(2),
                  sales: parseFloat(supervisor.progress).toFixed(2),
                  progress_percentage: `${parseInt(supervisor.progress_percentage)} %`,
                  code: supervisor.code,
                  dni: supervisor.dni,
                  phone: supervisor.phone,
                  state: supervisor.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
